import { render, staticRenderFns } from "./FontSize.vue?vue&type=template&id=3e675304&scoped=true"
import script from "./FontSize.vue?vue&type=script&lang=js"
export * from "./FontSize.vue?vue&type=script&lang=js"
import style0 from "./FontSize.vue?vue&type=style&index=0&id=3e675304&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e675304",
  null
  
)

export default component.exports